import { Stepper, StepperProps } from '@material-ui/core';
import React from 'react';
import styles from './SGSStepper.module.scss';

type Props = StepperProps;

const SGSStepper: React.FC<Props> = ({ children, ...props }) => {
    return (
        <Stepper {...props} alternativeLabel classes={{ root: styles.stepper }}>
            {children}
        </Stepper>
    );
};

export default SGSStepper;
